export default {
  created: function() {
    // 更新面包屑，注意此处不能用箭头函数，否则this报错
    let breadcrumb = this.$data.breadcrumb
    if (breadcrumb) {
      this.$store.commit("update_breadcrumb", breadcrumb)
    }
  }
}
